import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ListSerializer1hxuk9dx5n9du as ListSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  sortedWith2csnbbb21k0lg as sortedWith,
  take3onnpy6q7ctcz as take,
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  contains3ue2qo8xhmpf1 as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { debounce302w6e33401uo as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  Cursor37k0vceqk2231 as Cursor,
  bindToArrowKeys1daveb700wdu5 as bindToArrowKeys,
  focusedIfCursorSelected22hr3iuy5vsdy as focusedIfCursorSelected,
} from '../../../utils/Cursor.mjs';
import {
  isUsingKeyboard18gbvw16gm0yg as isUsingKeyboard,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  resize3py5p2yrjp6p7 as resize,
  Action1a4ymn5nx79hk as Action,
} from '../../../utils/utils.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  ImageRemote256pcav1ipbca as ImageRemote,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  title1nssp3ryhwuqj as title,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  get_contractorStatus37lp78am5imju as get_contractorStatus,
  get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor,
} from '../../../selectedContractor.mjs';
import {
  ContractorStatus_Approved_getInstance2o21n9qt09k9q as ContractorStatus_Approved_getInstance,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  ContractorStatus_AwaitingApproval_getInstance3rsoledcr0pzu as ContractorStatus_AwaitingApproval_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance,
  get_outlinedfhcs63de0vzu as get_outlined,
} from '../../theming/appTheme.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../../screens/contractor/ContractorProject.mjs';
import { EditProject1iovryfu514gb as EditProject } from '../../screens/contractor/EditProject.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from '../../screens/client/ClientProject.mjs';
import { ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance } from '../../screens/common/ProjectView.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  Contractor1wog4uk4l8u77 as Contractor,
  Clientuccelyr89ch8 as Client,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { isUnread2u0ehyt0ioouz as isUnread } from '../../../extensions/HasReadBy.ext.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic } from '../../theming/states.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { contactInfo32uf9r8bl14q as contactInfo } from '../contact.mjs';
import { get_trash3qsdn4kaynjmu as get_trash } from '../../../icons.mjs';
import { CreateProject30799kzrue0ed as CreateProject } from '../../screens/contractor/CreateProject.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  get_windowIsNarrow3aab1t9rdaelq as get_windowIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
} from '../nav/crowpay.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.crowpay.views.components.project.RecentsTracker.Usage', this, 2);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('timestamp', true);
        this.rh0_1 = tmp0_serialDesc;
      }
      sh0(encoder, value) {
        var tmp0_desc = this.rh0_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.th0_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.uh0_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), value.uh0_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.sh0(encoder, value instanceof Usage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.rh0_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return Usage().vh0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.rh0_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), InstantIso8601Serializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var UsageClass;
function Usage() {
  if (UsageClass === VOID) {
    class $ {
      constructor(id, timestamp) {
        var tmp;
        if (timestamp === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = timestamp;
        }
        timestamp = tmp;
        this.th0_1 = id;
        this.uh0_1 = timestamp;
      }
      cf() {
        return this.th0_1;
      }
      toString() {
        return 'Usage(id=' + this.th0_1.toString() + ', timestamp=' + this.uh0_1.toString() + ')';
      }
      hashCode() {
        var result = this.th0_1.hashCode();
        result = imul(result, 31) + this.uh0_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Usage()))
          return false;
        if (!this.th0_1.equals(other.th0_1))
          return false;
        if (!this.uh0_1.equals(other.uh0_1))
          return false;
        return true;
      }
      static vh0(seen0, id, timestamp, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().rh0_1);
        }
        var $this = createThis(this);
        $this.th0_1 = id;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.uh0_1 = get_default(Companion_instance).b1m();
        } else
          $this.uh0_1 = timestamp;
        return $this;
      }
    }
    initMetadataForClass($, 'Usage', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    UsageClass = $;
  }
  return UsageClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.wh0_1 = function_0;
      }
      wi(a, b) {
        return this.wh0_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.wh0_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function RecentsTracker$used$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.uh0_1;
  var tmp$ret$1 = a.uh0_1;
  return compareValues(tmp, tmp$ret$1);
}
var RecentsTrackerClass;
function RecentsTracker() {
  if (RecentsTrackerClass === VOID) {
    class $ {
      constructor() {
        RecentsTracker_instance = this;
        this.xh0_1 = 3;
        this.yh0_1 = PersistentProperty().qd8('recent-projects', emptyList(), ListSerializer(Companion_instance_0.k2a()));
      }
      zh0(id) {
        var list = toMutableList(this.yh0_1.f2());
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = list.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            if (item.th0_1.equals(id)) {
              tmp$ret$1 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$1 = -1;
        }
        var idx = tmp$ret$1;
        if (idx === -1)
          list.v(new (Usage())(id));
        else {
          list.b2(idx, new (Usage())(id));
        }
        // Inline function 'kotlin.collections.sortedByDescending' call
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp = RecentsTracker$used$lambda;
        var tmp$ret$2 = new (sam$kotlin_Comparator$0())(tmp);
        var tmp$ret$3 = sortedWith(list, tmp$ret$2);
        this.yh0_1.oam(take(tmp$ret$3, 3));
      }
      ah1(_this__u8e3s4, items) {
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = _this__u8e3s4.daj(this.yh0_1);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var id = element.cf();
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_0 = items.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              if (element_0.f40().equals(id)) {
                tmp$ret$1 = element_0;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_safe_receiver = tmp$ret$1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.v(tmp0_safe_receiver);
          }
        }
        return destination;
      }
      v3() {
        this.yh0_1.oam(emptyList());
      }
    }
    initMetadataForObject($, 'RecentsTracker');
    RecentsTrackerClass = $;
  }
  return RecentsTrackerClass;
}
var RecentsTracker_instance;
function RecentsTracker_getInstance() {
  if (RecentsTracker_instance === VOID)
    new (RecentsTracker())();
  return RecentsTracker_instance;
}
function weightedLcs(query, match) {
  return lcsLength(match, query) / match.length;
}
function lcsLength(s1, s2) {
  var m = s1.length;
  var n = s2.length;
  var tmp = 0;
  var tmp_0 = m + 1 | 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = Array(tmp_0);
  while (tmp < tmp_0) {
    tmp_1[tmp] = new Int32Array(n + 1 | 0);
    tmp = tmp + 1 | 0;
  }
  var dp = tmp_1;
  var inductionVariable = 1;
  if (inductionVariable <= m)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 1;
      if (inductionVariable_0 <= n)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp_2 = dp[i];
          var tmp_3;
          if (charCodeAt(s1, i - 1 | 0) === charCodeAt(s2, j - 1 | 0)) {
            tmp_3 = dp[i - 1 | 0][j - 1 | 0] + 1 | 0;
          } else {
            var tmp0 = dp[i - 1 | 0][j];
            // Inline function 'kotlin.comparisons.maxOf' call
            var b = dp[i][j - 1 | 0];
            tmp_3 = Math.max(tmp0, b);
          }
          tmp_2[j] = tmp_3;
        }
         while (!(j === n));
    }
     while (!(i === m));
  return dp[m][n];
}
function containsAllParts(_this__u8e3s4, string) {
  var tmp0 = split(string, charArrayOf([_Char___init__impl__6a9atx(32)]));
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!contains(_this__u8e3s4, element, true)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function projectList(_this__u8e3s4, lens, projects, contacts, showArchivedProjects) {
  var search = Signal().hak('');
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  var debouncedSearch = debounce(search, tmp$ret$0);
  var recents = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.run' call
    return RecentsTracker_getInstance().ah1($this$remember, $this$remember.daj(projects));
  });
  var filteredAndSorted = remember(VOID, VOID, VOID, ($this$remember) => {
    var query = $this$remember.daj(debouncedSearch);
    var tmp;
    if (isBlank(query)) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$remember.daj(recents);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$3 = item.v7a_1;
        destination.v(tmp$ret$3);
      }
      var r = toSet(destination);
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.daj(projects);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList().w();
      var _iterator__ex2g4s_0 = tmp0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element = _iterator__ex2g4s_0.o1();
        if (!r.t1(element.v7a_1)) {
          destination_0.v(element);
        }
      }
      tmp = destination_0;
    } else {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_0 = $this$remember.daj(projects);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList().w();
      var _iterator__ex2g4s_1 = tmp0_0.m1();
      while (_iterator__ex2g4s_1.n1()) {
        var element_0 = _iterator__ex2g4s_1.o1();
        if (containsAllParts(element_0.b7b_1, query)) {
          destination_1.v(element_0);
        }
      }
      // Inline function 'kotlin.collections.sortedByDescending' call
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_0 = (a, b) => {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        var tmp = weightedLcs(query, b.b7b_1);
        var tmp$ret$13 = weightedLcs(query, a.b7b_1);
        return compareValues(tmp, tmp$ret$13);
      };
      var tmp$ret$15 = new (sam$kotlin_Comparator$0_0())(tmp_0);
      tmp = sortedWith(destination_1, tmp$ret$15);
    }
    return tmp;
  });
  var tmp;
  if (isUsingKeyboard(_this__u8e3s4)) {
    tmp = Cursor(($this$Cursor) => {
      // Inline function 'kotlin.takeIf' call
      var this_0 = $this$Cursor.daj(recents);
      var tmp;
      if (isBlank($this$Cursor.daj(search))) {
        tmp = this_0;
      } else {
        tmp = null;
      }
      var tmp0_elvis_lhs = tmp;
      return plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, $this$Cursor.daj(filteredAndSorted));
    });
  } else {
    tmp = null;
  }
  var cursor = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().bg2_1);
  if (cursor == null)
    null;
  else {
    bindToArrowKeys(view, cursor);
  }
  if (!(cursor == null)) {
    var wasBlank = {_v: true};
    reactive(view, ($this$reactive) => {
      var blank = isBlank($this$reactive.daj(search));
      var tmp;
      if (!(wasBlank._v === blank)) {
        cursor.zg2_1.oam(null);
        tmp = Unit_instance;
      }
      wasBlank._v = blank;
      return Unit_instance;
    });
  }
  var tmp_0 = get_compact(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lbb(get_expanding(view_0), title(view_0, 'Projects'));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  shownDefaultFalse(view_1, projectList$lambda);
  var tmp_1 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Show Archived Projects';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_2 = view_2.vb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = content;
  }
  tmp_2.hbu(tmp_3);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_1, view_2);
  var tmp_4 = get_centered(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Checkbox())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  view_3.zah(view_3.ebk_1, showArchivedProjects);
  view_1.hbb(p_3, view_3);
  view_1.lbb(tmp_4, view_3);
  view_0.hbb(p_1, view_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(false);
  var tmp_5 = get_centered(view_4);
  var tmp_6 = view_4.kbb(view_4.kbb(tmp_5, shownWhen(view_4, VOID, projectList$lambda_0)), get_primaryButton(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Button())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  specCenteredText(view_5, '+ Project');
  onClick(view_5, VOID, VOID, projectList$slambda_0(view_5));
  view_4.hbb(p_5, view_5);
  view_4.lbb(tmp_6, view_5);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$38 = view_4.jbb(FieldSemantic_getInstance());
  var tmp_7 = view_4.kbb(view_4.kbb(tmp$ret$38, get_expanding(view_4)), get_compact(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.zbm(false);
  view_6.lbb(get_centered(view_6), icon(view_6, resize(Companion_getInstance_0().scf_1, get_rem(1.1)), 'search'));
  var tmp_8 = view_6.kbb(get_centered(view_6), get_expanding(view_6));
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextInput())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  if (isUsingKeyboard(view_7)) {
    view_7.qb9();
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  var value = 'Search by name...';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_7.vb5_1.bb4_1.kb7_1.placeholder = value;
  view_7.zah(view_7.icn_1, search);
  view_7.obg(Action('Select First', VOID, projectList$slambda_2(cursor, filteredAndSorted, view_7, lens)));
  view_6.hbb(p_7, view_7);
  view_6.lbb(tmp_8, view_7);
  var tmp_9 = get_centered(view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (Button())(view_6.pc());
  var tmp0_elvis_lhs_8 = view_6.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
  view_6.gbb(p_8, view_8);
  icon(view_8, resize(Companion_getInstance_0().vcf_1, get_rem_0(1)), 'clear');
  onClick(view_8, VOID, VOID, projectList$slambda_4(search));
  view_6.hbb(p_8, view_8);
  view_6.lbb(tmp_9, view_8);
  view_4.hbb(p_6, view_6);
  view_4.lbb(tmp_7, view_6);
  view.hbb(p_4, view_4);
  var tmp_10 = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => {
    var active = $this$shownWhen.daj(get_contractorStatus());
    return $this$shownWhen.daj(projects).i1() && (active == null || equals(active, ContractorStatus_Approved_getInstance()));
  }), view.jbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_9 = view.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
  view.gbb(p_9, view_9);
  view_9.zbm(true);
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextView())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.gbb(p_10, view_10);
  view_10.lba(view_10.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_10.dbs(Align_Center_getInstance());
  var tmp_11;
  switch (lens.b4_1) {
    case 0:
      tmp_11 = 'No Contracts Yet';
      break;
    case 1:
      tmp_11 = 'No Projects Yet';
      break;
    case 2:
      tmp_11 = '';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = tmp_11;
  var tmp_12 = view_10.vb5_1;
  var tmp_13;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_13 = '\xA0';
  } else {
    tmp_13 = value_0;
  }
  tmp_12.hbu(tmp_13);
  view_9.hbb(p_10, view_10);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (TextView())(view_9.pc());
  var tmp0_elvis_lhs_11 = view_9.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
  view_9.gbb(p_11, view_11);
  view_11.lba(view_11.qb6_1.abf(SmallBodySemantic_getInstance()));
  view_11.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_1 = 'Projects will appear here once ' + (lens.zgj() ? 'accepted' : 'created');
  var tmp_14 = view_11.vb5_1;
  var tmp_15;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_1) === 0) {
    tmp_15 = '\xA0';
  } else {
    tmp_15 = value_1;
  }
  tmp_14.hbu(tmp_15);
  view_9.hbb(p_11, view_11);
  view.hbb(p_9, view_9);
  view.lbb(tmp_10, view_9);
  var tmp_16 = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this$shownWhen.daj(projects).i1()) {
      tmp = $this$shownWhen.daj(filteredAndSorted).i1();
    } else {
      tmp = false;
    }
    return tmp;
  }), view.jbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_12 = view.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view : tmp0_elvis_lhs_12;
  view.gbb(p_12, view_12);
  view_12.zbm(true);
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (TextView())(view_12.pc());
  var tmp0_elvis_lhs_13 = view_12.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
  view_12.gbb(p_13, view_13);
  view_13.lba(view_13.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_13.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_2 = 'No Matching Projects';
  var tmp_17 = view_13.vb5_1;
  var tmp_18;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_2) === 0) {
    tmp_18 = '\xA0';
  } else {
    tmp_18 = value_2;
  }
  tmp_17.hbu(tmp_18);
  view_12.hbb(p_13, view_13);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (TextView())(view_12.pc());
  var tmp0_elvis_lhs_14 = view_12.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
  view_12.gbb(p_14, view_14);
  view_14.lba(view_14.qb6_1.abf(SmallBodySemantic_getInstance()));
  view_14.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_3 = 'Try a different search, it might just be a spelling mistake.';
  var tmp_19 = view_14.vb5_1;
  var tmp_20;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_3) === 0) {
    tmp_20 = '\xA0';
  } else {
    tmp_20 = value_3;
  }
  tmp_19.hbu(tmp_20);
  view_12.hbb(p_14, view_14);
  view.hbb(p_12, view_12);
  view.lbb(tmp_16, view_12);
  var tmp_21 = view.kbb(get_scrolling(view), get_expanding(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_15 = view.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view : tmp0_elvis_lhs_15;
  view.gbb(p_15, view_15);
  view_15.zbm(true);
  var tmp_22 = shownWhen(view_15, true, ($this$shownWhen) => isBlank($this$shownWhen.daj(search)));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (RowOrCol())(view_15.pc());
  var tmp0_elvis_lhs_16 = view_15.ebb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
  view_15.gbb(p_16, view_16);
  view_16.zbm(true);
  var tmp_23 = get_compact(view_16);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (RowOrCol())(view_16.pc());
  var tmp0_elvis_lhs_17 = view_16.ebb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
  view_16.gbb(p_17, view_17);
  view_17.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (RowOrCol())(view_17.pc());
  var tmp0_elvis_lhs_18 = view_17.ebb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
  view_17.gbb(p_18, view_18);
  view_18.zbm(false);
  view_18.lbb(get_expanding(view_18), boldSubTitle(view_18, 'Recents'));
  var tmp_24 = view_18.kbb(get_centered(view_18), get_textButton(view_18));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_19 = new (Button())(view_18.pc());
  var tmp0_elvis_lhs_19 = view_18.ebb_1;
  var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
  view_18.gbb(p_19, view_19);
  view_19.gba(get_dp(5));
  view_19.bb9(get_dp(5));
  smallBody(view_19, 'Clear Recents');
  onClick(view_19, VOID, VOID, projectList$slambda_6());
  view_18.hbb(p_19, view_19);
  view_18.lbb(tmp_24, view_19);
  view_17.hbb(p_18, view_18);
  greySeparator(view_17);
  view_16.hbb(p_17, view_17);
  view_16.lbb(tmp_23, view_17);
  shownDefaultFalse(view_16, ($this$shownDefaultFalse) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownDefaultFalse.daj(recents).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_20 = new (RowOrCol())(view_16.pc());
  var tmp0_elvis_lhs_20 = view_16.ebb_1;
  var p_20 = tmp0_elvis_lhs_20 == null ? view_16 : tmp0_elvis_lhs_20;
  view_16.gbb(p_20, view_20);
  view_20.zbm(true);
  forEachUpdating(view_20, recents, VOID, ($this$forEachUpdating, it) => {
    renderProjectCard($this$forEachUpdating, contacts, lens, it, cursor);
    return Unit_instance;
  });
  view_16.hbb(p_20, view_20);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (Space())(view_16.pc(), 2.0);
  var tmp0_elvis_lhs_21 = view_16.ebb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_16 : tmp0_elvis_lhs_21;
  view_16.gbb(p_21, view_21);
  view_16.hbb(p_21, view_21);
  view_15.hbb(p_16, view_16);
  view_15.lbb(tmp_22, view_16);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_22 = new (RowOrCol())(view_15.pc());
  var tmp0_elvis_lhs_22 = view_15.ebb_1;
  var p_22 = tmp0_elvis_lhs_22 == null ? view_15 : tmp0_elvis_lhs_22;
  view_15.gbb(p_22, view_22);
  view_22.zbm(true);
  forEachUpdating(view_22, filteredAndSorted, VOID, ($this$forEachUpdating, it) => {
    renderProjectCard($this$forEachUpdating, contacts, lens, it, cursor);
    return Unit_instance;
  });
  view_15.hbb(p_22, view_22);
  view.hbb(p_15, view_15);
  view.lbb(tmp_21, view_15);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function navigateToProject(_this__u8e3s4, project, lens) {
  RecentsTracker_getInstance().zh0(project.v7a_1);
  var to = lens.equals(ProjectLens_Customer_getInstance()) ? new (ClientProject())(project.v7a_1) : project.u7b_1.equals(ProjectState_Creating_getInstance()) ? new (EditProject())(project.v7a_1) : new (ContractorProject())(project.v7a_1);
  get_mainPageNavigator(_this__u8e3s4).fbw(to);
}
function renderProjectCard(_this__u8e3s4, contacts, lens, project, cursor) {
  cursor = cursor === VOID ? null : cursor;
  var contact = remember(VOID, VOID, VOID, ($this$remember) => {
    var p = $this$remember.daj(project);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = $this$remember.daj(contacts);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp;
        if (element instanceof Client()) {
          tmp = element.b5c_1.equals(p.a7b_1);
        } else {
          if (element instanceof Contractor()) {
            tmp = element.t5i_1.equals(p.x7a_1);
          } else {
            tmp = false;
          }
        }
        if (tmp) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  });
  var unread = remember(VOID, VOID, VOID, ($this$remember) => !$this$remember.daj(project).u7b_1.equals(ProjectState_Creating_getInstance()) && isUnread($this$remember.daj(project), $this$remember.daj(get_session()).gfv_1));
  var tmp = _this__u8e3s4.kbb(get_outlined(_this__u8e3s4), get_unpadded(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_dp(0));
  focusedIfCursorSelected(view, cursor, project);
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_1.pc(), 0.1);
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_1.hbb(p_2, view_2);
  var tmp_1 = get_expanding(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_rem_0(60);
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  view_3.bb9(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint_0 = get_AppDimensions().hg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowCollapsingToColumn())(view_3.pc(), listOf(new (Dimension())(breakpoint_0)));
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.zbm(false);
  view_5.bb9(get_AppDimensions().og2_1);
  get_centered(view_5);
  unreadIconWhen(view_5, ($this$unreadIconWhen) => $this$unreadIconWhen.daj(unread));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance_1();
  var tmp_2 = get_centered(view_5);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$7 = $this$reactiveScope.daj(project).b7b_1;
    this_0.set(tmp$ret$7);
    return Unit_instance;
  });
  view_5.hbb(p_6, view_6);
  view_5.lbb(tmp_2, view_6);
  var tmp_5 = view_5.kbb(get_expanding(view_5), get_centered(view_5));
  var tmp_6 = view_5.kbb(tmp_5, shownWhen(view_5, false, renderProjectCard$lambda));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.gbb(p_7, view_7);
  view_7.lba(view_7.qb6_1.abf(BodySemantic_getInstance()));
  view_7.dbs(Align_End_getInstance());
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_0(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_0(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$14 = $this$reactiveScope.daj(project).u7b_1.u9b_1;
    this_1.set(tmp$ret$14);
    return Unit_instance;
  });
  dynamicTheme(view_7, ($this$dynamicTheme) => ProjectStateSemantic().eh1($this$dynamicTheme.daj(project).u7b_1));
  view_5.hbb(p_7, view_7);
  view_5.lbb(tmp_6, view_7);
  view_4.hbb(p_5, view_5);
  greySeparator(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_8 = view_4.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
  view_4.gbb(p_8, view_8);
  view_8.zbm(false);
  var tmp_9 = KMutableProperty0();
  var tmp_10 = RowOrCol$_get_visible_$ref_m9hbzh(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('visible', 0, tmp_9, tmp_10, RowOrCol$_set_visible_$ref_80wucf(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp$ret$25 = !($this$reactiveScope.daj(contact) == null);
    this_2.set(tmp$ret$25);
    return Unit_instance;
  });
  var tmp_11 = view_8.kbb(sizeConstraints(view_8, VOID, VOID, VOID, VOID, VOID, get_rem_0(3), get_rem_0(3)), get_centered(view_8));
  // Inline function 'com.lightningkite.kiteui.views.direct.image' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (ImageView())(view_8);
  var tmp0 = this_3.cda_1;
  var tmp_12 = KMutableProperty0();
  var tmp_13 = Frame$_get_shown_$ref_dnks5k(tmp0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('shown', 0, tmp_12, tmp_13, Frame$_set_shown_$ref_s2otf0(tmp0));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(contact);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q92();
    var tmp$ret$27 = !((tmp == null ? null : new (ServerFile())(tmp)) == null);
    this_4.set(tmp$ret$27);
    return Unit_instance;
  });
  var tmp_14 = KMutableProperty0();
  var tmp_15 = ImageView$_get_source_$ref_ain7z1(this_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('source', 0, tmp_14, tmp_15, ImageView$_set_source_$ref_4jld67(this_3));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(contact);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q92();
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp$ret$29 = new (ImageRemote())(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
    this_5.set(tmp$ret$29);
    return Unit_instance;
  });
  this_3.bbb();
  view_8.lbb(tmp_11, this_3);
  get_centered(view_8);
  contactInfo(view_8, contact);
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance_1();
  view_4.hbb(p_8, view_8);
  view_3.hbb(p_4, view_4);
  var tmp_16 = view_3.kbb(get_expanding(view_3), align(view_3, Align_End_getInstance(), Align_Center_getInstance()));
  var tmp_17 = view_3.kbb(tmp_16, shownWhen(view_3, VOID, renderProjectCard$lambda_0));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_9 = view_3.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_3 : tmp0_elvis_lhs_9;
  view_3.gbb(p_9, view_9);
  view_9.lba(view_9.qb6_1.abf(BodySemantic_getInstance()));
  view_9.dbs(Align_End_getInstance());
  var tmp_18 = KMutableProperty0();
  var tmp_19 = TextView$_get_content_$ref_4pzcwl_1(view_9);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_6 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, TextView$_set_content_$ref_pketfb_1(view_9));
  reactiveScope(view_9, ($this$reactiveScope) => {
    var tmp$ret$43 = $this$reactiveScope.daj(project).u7b_1.u9b_1;
    this_6.set(tmp$ret$43);
    return Unit_instance;
  });
  dynamicTheme(view_9, ($this$dynamicTheme) => ProjectStateSemantic().eh1($this$dynamicTheme.daj(project).u7b_1));
  view_3.hbb(p_9, view_9);
  view_3.lbb(tmp_17, view_9);
  view_1.hbb(p_3, view_3);
  view_1.lbb(tmp_1, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Space())(view_1.pc(), 0.1);
  var tmp0_elvis_lhs_10 = view_1.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
  view_1.gbb(p_10, view_10);
  view_1.hbb(p_10, view_10);
  view_0.hbb(p_1, view_1);
  onClick(view_0, VOID, VOID, renderProjectCard$slambda_0(view_0, project, lens));
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  var tmp_20 = get_deleteButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (Button())(view.pc());
  var tmp0_elvis_lhs_11 = view.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view : tmp0_elvis_lhs_11;
  view.gbb(p_11, view_11);
  view_11.gba(get_AppDimensions().zg1_1);
  view_11.bb9(get_AppDimensions().zg1_1);
  shownDefaultFalse(view_11, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(project).u7b_1.equals(ProjectState_Creating_getInstance()));
  view_11.lbb(get_centered(view_11), icon(view_11, resize(get_trash(Companion_getInstance_0()), get_rem(1.25)), 'Delete'));
  onClick(view_11, VOID, VOID, renderProjectCard$slambda_2(project));
  view.hbb(p_11, view_11);
  view.lbb(tmp_20, view_11);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.fh1_1 = function_0;
      }
      wi(a, b) {
        return this.fh1_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.fh1_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function projectList$lambda($this$shownDefaultFalse) {
  var active = $this$shownDefaultFalse.daj(get_contractorStatus());
  return !equals(active, ContractorStatus_AwaitingApproval_getInstance());
}
function projectList$lambda_0($this$shownWhen) {
  var tmp;
  if (!($this$shownWhen.daj(get_selectedContractor()) == null) && equals($this$shownWhen.daj(get_contractorStatus()), ContractorStatus_Approved_getInstance())) {
    var tmp0_safe_receiver = $this$shownWhen.daj($this$shownWhen.daj(get_session()).rfw_1).k88_1;
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
    tmp = (!(it == null) && it.d4(MemberRole_Manager_getInstance()) >= 0);
  } else {
    tmp = false;
  }
  return tmp;
}
var projectList$slambdaClass;
function projectList$slambda() {
  if (projectList$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.gh1_1 = $$this$button;
      }
      uao($completion) {
        get_mainPageNavigator(this.gh1_1).fbw(new (CreateProject())());
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectList$slambdaClass = $;
  }
  return projectList$slambdaClass;
}
function projectList$slambda_0($$this$button) {
  var i = new (projectList$slambda())($$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  var tmp0_safe_receiver = $this.hh1_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = tmp0_safe_receiver.ag3_1;
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.ih1_1;
    var tmp_2 = await_0(this_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$1 = tmp_2;
    tmp_1 = firstOrNull(tmp$ret$1);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var tmp2_safe_receiver = tmp_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    navigateToProject($this.jh1_1, tmp2_safe_receiver, $this.kh1_1);
  }
  return Unit_instance;
}
var projectList$slambdaClass_0;
function projectList$slambda_1() {
  if (projectList$slambdaClass_0 === VOID) {
    class $ {
      constructor($cursor, $filteredAndSorted, $$this$textInput, $lens) {
        this.hh1_1 = $cursor;
        this.ih1_1 = $filteredAndSorted;
        this.jh1_1 = $$this$textInput;
        this.kh1_1 = $lens;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    projectList$slambdaClass_0 = $;
  }
  return projectList$slambdaClass_0;
}
function projectList$slambda_2($cursor, $filteredAndSorted, $$this$textInput, $lens) {
  var i = new (projectList$slambda_1())($cursor, $filteredAndSorted, $$this$textInput, $lens);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var projectList$slambdaClass_1;
function projectList$slambda_3() {
  if (projectList$slambdaClass_1 === VOID) {
    class $ {
      constructor($search) {
        this.lh1_1 = $search;
      }
      uao($completion) {
        this.lh1_1.oam('');
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectList$slambdaClass_1 = $;
  }
  return projectList$slambdaClass_1;
}
function projectList$slambda_4($search) {
  var i = new (projectList$slambda_3())($search);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var projectList$slambdaClass_2;
function projectList$slambda_5() {
  if (projectList$slambdaClass_2 === VOID) {
    class $ {
      uao($completion) {
        RecentsTracker_getInstance().v3();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    projectList$slambdaClass_2 = $;
  }
  return projectList$slambdaClass_2;
}
function projectList$slambda_6() {
  var i = new (projectList$slambda_5())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function renderProjectCard$lambda($this$shownWhen) {
  return $this$shownWhen.daj(get_windowIsNarrow());
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_visible_$ref_m9hbzh(p0) {
  return () => p0.ab9();
}
function RowOrCol$_set_visible_$ref_80wucf(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.yb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return () => p0.g2i();
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return (_this__u8e3s4) => {
    p0.qda(_this__u8e3s4);
    return Unit_instance;
  };
}
function renderProjectCard$lambda_0($this$shownWhen) {
  return !$this$shownWhen.daj(get_windowIsNarrow());
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nh1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  navigateToProject($this.mh1_1, tmp$ret$0, $this.oh1_1);
  return Unit_instance;
}
var renderProjectCard$slambdaClass;
function renderProjectCard$slambda() {
  if (renderProjectCard$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $project, $lens) {
        this.mh1_1 = $$this$button;
        this.nh1_1 = $project;
        this.oh1_1 = $lens;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderProjectCard$slambdaClass = $;
  }
  return renderProjectCard$slambdaClass;
}
function renderProjectCard$slambda_0($$this$button, $project, $lens) {
  var i = new (renderProjectCard$slambda())($$this$button, $project, $lens);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.rfv_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.ph1_1;
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$1 = tmp_1;
    var tmp_2 = tmp_0.mft(tmp$ret$1.v7a_1).kem($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var renderProjectCard$slambda$slambdaClass;
function renderProjectCard$slambda$slambda() {
  if (renderProjectCard$slambda$slambdaClass === VOID) {
    class $ {
      constructor($project) {
        this.ph1_1 = $project;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderProjectCard$slambda$slambdaClass = $;
  }
  return renderProjectCard$slambda$slambdaClass;
}
function renderProjectCard$slambda$slambda_0($project) {
  var i = new (renderProjectCard$slambda$slambda())($project);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var renderProjectCard$slambdaClass_0;
function renderProjectCard$slambda_1() {
  if (renderProjectCard$slambdaClass_0 === VOID) {
    class $ {
      constructor($project) {
        this.qh1_1 = $project;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Delete Draft?', 'You are about to delete this project draft. Deleted drafts cannot be recovered. Delete this draft?', VOID, 'Delete Draft', VOID, tmp_0, VOID, VOID, VOID, VOID, renderProjectCard$slambda$slambda_0(this.qh1_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderProjectCard$slambdaClass_0 = $;
  }
  return renderProjectCard$slambdaClass_0;
}
function renderProjectCard$slambda_2($project) {
  var i = new (renderProjectCard$slambda_1())($project);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  projectList as projectList120z2nvqx0g4u,
};
//endregion

//# sourceMappingURL=projectList.mjs.map
